import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { FeeMethod } from '@eastcoal/shared/enums/FeeMethod'

export const entranceFeeValidator: SchemaItem['x-validator'] = {
  validator(value: {
    entranceFeeMethod: FeeMethod
    entranceFeeValue?: number
  }) {
    if (value.entranceFeeMethod === FeeMethod.NONE) {
      return null
    }

    if (isNil(value.entranceFeeValue)) {
      return '入场费值不能为空'
    }

    if (value.entranceFeeValue <= 0) {
      return '入场费值必须大于0'
    }

    return null
  }
}
